import { render, staticRenderFns } from "./_RecycleFinalDisposalBasic.vue?vue&type=template&id=25c6e766&scoped=true&"
import script from "./_RecycleFinalDisposalBasic.vue?vue&type=script&lang=js&"
export * from "./_RecycleFinalDisposalBasic.vue?vue&type=script&lang=js&"
import style0 from "./_RecycleFinalDisposalBasic.vue?vue&type=style&index=0&id=25c6e766&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6e766",
  null
  
)

export default component.exports